import {
  useIsMobile,
  useModalContext,
  WSButton,
  WSDivider,
  WSFilters,
  WSPage,
  WSText
} from "@wingspanhq/fe-component-library";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useMemberClientsQuery } from "../../query/payments/queries";
import { getClients } from "../../query/payments/selectors";
import { WSQueries } from "../../query/WSQuery";
import {
  AddClientModal,
  ADD_CLIENT_MODAL
} from "../components/AddClientModal/AddClientModal";
import { ClientsTable } from "../components/ClientsTable/ClientsTable";

export const InvoicesClients: React.FC = () => {
  const history = useHistory();
  const memberClientsQuery = useMemberClientsQuery();
  const { openModal } = useModalContext();
  const [searchText, setSearchText] = useState("");
  const isMobile = useIsMobile();

  return (
    <>
      <AddClientModal />
      <WSPage
        title="Clients"
        breadcrumb={{
          label: "Contacts",
          icon: "back",
          onClick: () => {
            history.push("/member/invoices/contacts");
          }
        }}
        primaryButtonComponent={props => (
          <WSButton
            onClick={() => {
              openModal(ADD_CLIENT_MODAL);
            }}
            {...props}
          >
            Add client
          </WSButton>
        )}
      >
        <WSQueries queries={{ memberClientsQuery }}>
          {({ memberClientsQuery: { data: memberClients } }) => {
            let filteredMemberClients = getClients(memberClients);

            if (searchText) {
              filteredMemberClients = filteredMemberClients.filter(
                memberClient =>
                  memberClient.company?.toLowerCase().includes(searchText) ||
                  memberClient.name?.toLowerCase().includes(searchText) ||
                  memberClient.emailTo?.toLowerCase().includes(searchText) ||
                  memberClient.emailCC?.some(email =>
                    email
                      .toLowerCase()
                      .toLowerCase()
                      .includes(searchText)
                  )
              );
            }

            return (
              <>
                {isMobile && <WSDivider fullScreen my="M" />}

                <WSFilters
                  onSearch={newSearchText => {
                    setSearchText(newSearchText.toLowerCase());
                  }}
                  searchQuery={searchText}
                  mb={isMobile ? "S" : "L"}
                />

                {filteredMemberClients.length > 0 ? (
                  <ClientsTable
                    memberClients={filteredMemberClients}
                    listPath="/member/invoices/contacts/clients"
                  />
                ) : searchText ? (
                  <WSText>
                    No results found.{" "}
                    <WSButton.Link
                      inline
                      onClick={() => {
                        setSearchText("");
                      }}
                    >
                      Clear search
                    </WSButton.Link>
                  </WSText>
                ) : (
                  <WSText>
                    No clients yet.{" "}
                    <WSButton
                      kind="Link"
                      inline
                      onClick={() => {
                        openModal(ADD_CLIENT_MODAL);
                      }}
                    >
                      Add a client
                    </WSButton>
                  </WSText>
                )}
              </>
            );
          }}
        </WSQueries>
      </WSPage>
    </>
  );
};
